const dev = {
  // base_url: "http://192.168.10.167:2024/"  //janen
  base_url: "http://127.0.0.1:2034/" //sasi
  // base_url: "https://ancient-catfish-71.loca.lt/" //sasi
  // base_url: "http://192.168.10.214:2034/" //rajendran
  // base_url: "http://192.168.10.202:2024/"  //jp
};

const staging = {
  base_url: "https://apistaging.magnumclothing.com/"
};

const production = {
  // base_url: "http://13.234.124.200:2024/" old one before PWA
  // base_url: " https://api.magnumclothing.com/"
   base_url: "https://apistaging.magnumclothing.com/"
};

let configVariables = { ...dev };
//Change the config for production and development
switch (process.env.REACT_APP_BUILD_ENV) {
  case "staging":
    configVariables = { ...staging };
    break;
  case "production":
    configVariables = { ...production };
    break;
  default:
    configVariables = {
      ...dev
    };
    break;
}

export default {
  ...configVariables
};



// WEBPACK FOOTER //
// ./src/services/api.js